<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Host Name</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <div class="alert alert-warning" role="alert" v-if="[3, 4].includes(logged_in_user.group_id)">
          <b>Notice:</b> Changing the Host Name requires a restart.
        </div>
        <form>
          <div class="form-group">
            <label>Current Host Name</label>
            <input type="text" class="form-control" disabled="disabled" :value="host_name" />
          </div>
          <div v-if="[3, 4].includes(logged_in_user.group_id)">
            <div class="form-group">
              <label>Set Host Name</label>
              <input type="text" class="form-control" v-model="updated_host_name" />
            </div>
            <button type="submit" class="btn btn-hub-primary" @click="save()">Set</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'host-name',
  data: function () {
    return {
      updated_host_name: ''
    }
  },
  computed: mapGetters({
    host_name: 'hostName',
    logged_in_user: 'loggedInUser'
  }),
  methods: {
    save () {
      this.$store.dispatch('setHostName', this.updated_host_name)
    }
  },
  created () {
    this.$store.dispatch('getHostName')
  }
}
</script>

<style scoped>

</style>
